import zonedTimeToUtc from 'date-fns-tz/zonedTimeToUtc';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

/**
 * example output: "12:00 PM"
 */
export const formatTo12HourTime = (date: string | Date): string => {
  return date ? format(parseDate(date), 'h:mm aa') : '';
};

/**
 * example output: "Wed, Jan 1 • 12:00 PM"
 */
export const formatToFriendlyDateTime = (date: string | Date): string => {
  return date ? format(parseDate(date), "EEE, MMM d '•' h:mm a") : '';
};

/**
 * example output: "01-01-2023"
 */
export const formatToSimpleDate = (date: string | Date): string => {
  return date ? format(parseDate(date), 'MM-dd-yyyy') : '';
};

/**
 * example output: "03-14-2025, 10:30 AM"
 */
export const formatToSimpleDateWithTime = (date: string | Date): string => {
  return date ? format(parseDate(date), 'MM-dd-yyyy, h:mm a') : '';
};

export const convertToUTC = ({ date, timeZone }: { date: Date; timeZone?: string }): Date => {
  if (!timeZone) return date;
  return zonedTimeToUtc(date, timeZone);
};

const parseDate = (date: string | Date): Date => {
  if (typeof date === 'string') {
    return parseISO(date);
  }
  return date;
};
